import { render, staticRenderFns } from "./precarriage-list.vue?vue&type=template&id=4af003da"
import script from "./precarriage-list.vue?vue&type=script&lang=js"
export * from "./precarriage-list.vue?vue&type=script&lang=js"
import style0 from "./precarriage-list.vue?vue&type=style&index=0&id=4af003da&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports